/* eslint-disable no-nested-ternary */
/* eslint-disable no-restricted-syntax */
import { StringOrNull } from 'utils/types/types';

const endPointURLs = {
  getApplicationDetail: (applicationId: string) =>
    `/onboarding/applications/${applicationId}`,
  getBranchList: (queryString: string) =>
    `/onboarding/sub-branches?asset_type_id=MOTOR&${queryString}`,
  getCities: (provinceCode: string) =>
    `/onboarding/address/${provinceCode}/city`,
  getCityById: (cityCode: string) => `/onboarding/address/cities/${cityCode}`,
  getDistrictById: (districtCode: string) =>
    `/onboarding/address/districts/${districtCode}`,
  getDistricts: (cityCode: string) =>
    `/onboarding/address/${cityCode}/district`,
  getMasterEntityOptions: () =>
    `/onboarding/master/entity_options?asset_type_id=MOTOR`,
  getProductLists: () => `/onboarding/product/packages`,
  getProvinceById: (provinceCode: string) =>
    `/onboarding/address/provinces/${provinceCode}`,
  getProvinces: () => `/onboarding/address/province`,
  getSearchCity: () => `/onboarding/address/search_city`,
  getSubDistrictById: (subDistrictCode: string) =>
    `/onboarding/address/subdistricts/${subDistrictCode}`,
  getSubDistricts: (districtCode: string) =>
    `/onboarding/address/${districtCode}/sub_district`,
  getUserInfo: (applicationNumber: StringOrNull) =>
    `/onboarding/info/${applicationNumber}`,
  getUserInfoWithCode: (groupCode: string) => `/onboarding/info/${groupCode}`,
  getVehicleBrands: () => `/onboarding/vehicles/brands/?asset_type_id=MOTOR`,
  getVehicleModel: (brandCode: string) =>
    `/onboarding/vehicles/${brandCode}/models/?asset_type_id=MOTOR`,
  getVehicleProvince: (queryParam?: string) =>
    queryParam
      ? `/onboarding/address/province?q=${queryParam}`
      : `/onboarding/address/province`,
  getVehicleProvinceCity: (provinceCode: string | null) =>
    `/onboarding/address/${provinceCode}/city`,
  getVehicleVariant: (modelCode: string) =>
    `/onboarding/vehicles/${modelCode}/variant/?asset_type_id=MOTOR`,
  getVehicleYear: () => `/onboarding/vehicles/years?asset_type_id=MOTOR`,
  patchApplicationBranchDetail: (applicationId: string) =>
    `/onboarding/applications/${applicationId}/branch`,
  patchApplicationDetail: (applicationId: string) =>
    `/onboarding/applications/${applicationId}`,
  patchApplicationPersonalInfo: (applicationId: string) =>
    `/onboarding/applications/${applicationId}/personal_information`,
  postApplicationDetailsConfirm: (applicationId: string) =>
    `/onboarding/applications/${applicationId}/confirm`,
  postCalculateInstallment: () =>
    `/onboarding/calculation/installment?asset_type_id=MOTOR`,
  postCollateral: () => `/onboarding/calculation/collateral`,
  postLiveliness: (groupId: string) =>
    `/onboarding/v3/verification/${groupId}/liveliness`,
  postUpdateApplicationStatus: (applicationId: string, status: string) =>
    `/onboarding/applications/${applicationId}/${status}`,
  postVerificationKTP: (
    applicationId: string, // Upload KTP to onboarding
  ) => `/onboarding/verification/upload_ktp/${applicationId}`,
  postVerificationLivelinessResult: (groupId: string) =>
    `/onboarding/v3/verification/${groupId}/liveliness_result`,
  putSubmitBasicInfo: (applicationId: string) =>
    `/onboarding/applications/${applicationId}/basic_info`,
  putSubmitKTPAddress: (applicationId: string) =>
    `/onboarding/verification/verify_ktp/${applicationId}`,
  postOnboardingValidateOTP: () => `/onboarding/v3/otp/authenticate/customer`,
  postOnboardingGenerateOTP: () => `/onboarding/v3/otp/generate/customer`,
  postOnboardingGenerateOTPResend: () =>
    `/onboarding/v3/otp/generate/customer?generate_type=RESEND`,
  postLogin: () => `/auth-service/v1/login`,
  postValidateOTP: () => `/auth-service/v1/otp/login/validate`,
  postValidateOTPResend: () => `/auth-service/v1/otp/resend`,
  postExtendToken: () => `/auth-service/v1/extend_access_token`,
  putChangePhoneNumber: (applicationId: string) =>
    `/onboarding/applications/${applicationId}/user_phone_number`,
  postValidatePhoneNumber: (applicationId: string) =>
    `/onboarding/applications/${applicationId}/validate_phone_number`,
  postValidateBranchCoverage: () =>
    `/onboarding/applications/validate_branch_coverage`,
  postUploadImage: (applicationId: string) =>
    `/onboarding/verification/upload_image/${applicationId}`, // Upload selfie and KTP to DMS
  postUploadSelfie: (
    applicationId: string, // Upload selfie to onboarding
  ) => `/onboarding/verification/upload_selfie/${applicationId}`,
  getUploadedSelfie: (applicationId: string) =>
    `/onboarding/verification/selfie/${applicationId}`,
  getVerifyApplicationStatus: (
    applicationId: string,
    applicationStatus: string,
  ) => `/onboarding/applications/${applicationId}/verify/${applicationStatus}`,
  getBranchBravoList: () => `/onboarding/branch/bravo`,
  postFeedback: (groupId: string) =>
    `/onboarding/v3/applications/${groupId}/feedback`,
  postGeoplaceList: () => `/onboarding/verification/geolocation/nearest_place`,
  postSubmitGeoplace: (applicationId: string) =>
    `/onboarding/verification/geolocation/${applicationId}`,
  getSurveyorDetails: (applicationId: string) =>
    `/onboarding/applications/${applicationId}/surveyor`,
  getFeedbackQuestions: (type: string) => `/onboarding/v1/questioners/${type}`,
  getSelfieIsUploaded: (applicationId: string) =>
    `/onboarding/verification/verify_selfie/${applicationId}`,
  getVerifyKTPAttempt: (applicationId: string) =>
    `/onboarding/applications/${applicationId}/number_of_attempt_verify_ktp`,
  postLeadRevive: (groupId: string) =>
    `/onboarding/v3/applications/${groupId}/revive`,
  getApplicationHistory: (applicationId: string) =>
    `/onboarding/applications/${applicationId}/status_history`,
  patchUpdateApplicationStatusBlackList: (applicationId: string) =>
    `/onboarding/applications/${applicationId}/blacklist_area`,
};

const HTTPEndPoints = new Proxy(endPointURLs, {
  get(target, name: any, receiver) {
    if (!Reflect.has(target, name)) {
      // console.error(`Oops!! API '${name}' not defined.s`)
      return '';
    }
    return (...props: any[]) =>
      (str => {
        const propObject =
          props.length > 0 && typeof props[props.length - 1] === 'object'
            ? props[props.length - 1]
            : false;
        if (!propObject) {
          return str;
        }
        const searchParams = new URLSearchParams();
        for (const key in propObject) {
          if (
            propObject[key] !== undefined &&
            propObject[key] !== null &&
            propObject[key] !== ''
          ) {
            searchParams.append(key, propObject[key]);
          }
        }
        return searchParams.toString() === ''
          ? str
          : `${
              str +
              (str.indexOf('?') >= 0 ? '&' : '?') +
              searchParams.toString()
            }`;
      })(Reflect.get(target, name, receiver).apply(this, props));
  },
});

export default HTTPEndPoints;
